import { Component, OnInit, ViewChild, Output, EventEmitter, ElementRef, HostListener, Input } from '@angular/core';
import { flyInOut, fadeIn, fade, staggeredCards, syncCards, zFade, customPosition, animateOpen, rotateOpen, rotateDown, Cart, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, steppedFly, storeFilters, storetitle,viewInfo,viewDesc,winkey, filter } from '../animations';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectComponent } from 'ng-select';
import { Observable } from 'rxjs/Rx';

import { StoreService } from '../../services/store.service';
import { UserService } from '../../services/user.service';
import { environment } from '../../environment';
import { Currency } from '../../models/currency';
import { Product } from '../../models/product';
import { Category } from '../../models/category';
import { Account } from '../../models/account';
import { Item } from '../../models/item';

import { Filter } from '../../models/filter.constructor';

declare var $: any
declare var MasterSlider: any

@Component({
  selector: 'items',
  templateUrl: './items.component.html',
  inputs: [ 'hideHeader', 'showFilters', 'staggerAnimate' ],
  providers: [ StoreService, UserService ],
  animations: [ flyInOut, staggeredCards, syncCards, fadeIn, fade, zFade, animateOpen, rotateOpen, rotateDown, customPosition, Cart, ProductInfo, Stock, CartStep, CartOverlay, CartBackdrop, steppedFly, storeFilters, storetitle, viewInfo, viewDesc, winkey, filter ]
})

export class ItemsComponent implements OnInit {

	@Input() hideHeader = false;
	@Input() showFilters:any = true;
	@Input() staggerAnimate = true;

	@Input() public set updateCart(val: string) {
      this.getCart();
    }

	@Output() addedItemtoCart:EventEmitter<string> = new EventEmitter();

	@ViewChild('FeatImage') FeatImage: ElementRef;
	@ViewChild('priceSort') priceSort: SelectComponent;
	@ViewChild('categoriesSort') categoriesSort: SelectComponent;

	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
	    
		// if ( event.code == 'ArrowRight' ) {
		//   this.nextItem();
		// }

		// if ( event.code == 'ArrowLeft' ) {
		//   this.prevItem();
		// }

	}

	selection: Array<any> = [];

	slider = true;
	filterCategories = false;
	enableCurrencySelector = false;
	
	title: string;
	header: any;
	headerHeight: any;
	headerAlign: any;
	subtitle: string;
	cartItems: any;

	image = new Image();
	itemquery = new Filter();

	accounts: Account;
	parentcategories: Category;
	categories: Category;
	currency:   Currency;
	currencies: Currency;
	purchasedItems: Item;
	allitems: Item;
	items: Item;
	products: Product;
	purchased: Product;
	
	custom: any;
	loadingCart: any;
	selectedItem: any;
	currencyOpen: any;
	
	filtersActive = false;
	flashCart = false;
	selectedImage = 0;
	itemOnPage = 0;
	itemsShownPerPage = 10;
	sortOptions: any[];
	optionsModel: any[];
	viewImage: any[];
	itemsInCart: any[];
	total: any;
	cart: any[];
	sidebar: any;
	customizer: any;
	
	storeAdvert: string;
	
	viewPanel = ['both'];
	showItemDetails = 'false';
	
	searching = false;
	showOwned = true;
	showImage = 0;
	itemPage = 0;
	itemsOnPage = 6;
	showCards = -1;
	numberOfItems = 0;
	staggeredFlow: any;

	hideOwned = false;
	hasProducts = false;
	loadingItems = 6;

	constructor(private storeService: StoreService,
				private userService: UserService,
				private route: ActivatedRoute,
				private sanitizer: DomSanitizer,
				private router: Router) {
		
		this.sortOptions = [
			{ value: 'asc', label: 'Lowest Price' },
			{ value: 'desc', label: 'Highest Price' }
		];

	}


	/**
	* Filters
	**/

	changeSort(selection, type?) { 
		this.itemquery.sort = selection.value;
		this.filtersActive = true;
		this.stagger(67);
		console.log('changeSort')
	}

	changeCategories(selection, type?) { 
		this.itemquery.category = selection.value;
		this.filtersActive = true;
		this.stagger(67);
	}

	filterItems(selection, type?) {
		this.filtersActive = true;
		this.stagger(67);
	}

	clearFilter() {
		this.itemquery.sort = 'ASC';
		this.itemquery.category = null;
		this.itemquery.filterItems = null;
	}

	clearItemFilter() { this.clearFilter(); }



	/**
	* Cart Handling
	**/

	addToCart(item, redirect?) {
		if ( item.limit == 0 || item.limit > item.owns ) {
			if ( this.inCart( item.id ) ) {
				this.router.navigate(['/checkout']);
			} else {
				this.addedItemtoCart.emit(item);
				this.storeService.addItem(item.id);
				this.updateCartButton();
				this.getCart();
			}
		}
	}

	getCart() {
		this.custom = this.storeService.getItemContents();
		this.cart = this.storeService.getCartContents();
		
		Promise.resolve( this.storeService.getItems(this.cart) ).then((cartdata) => {
			this.cartItems = cartdata;
		});

		Promise.resolve( this.storeService.getCartItemIDs() ).then((cartitems) => {
			this.itemsInCart = cartitems;
		});
	}
	
	// inCart( listingidentifier ) {
	// 	var exists = ( this.customizer.indexOf( listingidentifier ) > -1 ) ? true : false;
	// 	return exists;
	// }

	inCart( id ) {
		let incart = false;
		if ( this.cart.indexOf( id ) > -1 ) {
			incart = true;
		} else {
			if ( this.itemsInCart && this.itemsInCart.indexOf( id ) > -1 ) { 
				incart = true;
			}
		}
		return incart;
	}

	inAccount() {
		Promise.resolve( this.storeService.getPurchasedItems() ).then((accountCount) => {
			this.purchasedItems = accountCount;
		});
	}

	removeFromCart(itemIndex) {
		this.storeService.removeItem(itemIndex);
		this.getCart();
	}

	updateCartButton() {
		this.flashCart = true;
		setTimeout( () => { this.flashCart = false;  }, 5000);
	}
	




	/**
	* Item Selections (work in progress)
	**/

	toggleItem(item) {
		if ( this.isSelected(item) ) {
			this.subtractItem(item);
		} else {
			this.addItem(item);
		}
	}

	addItem(item) {
		this.storeService.addItem(item.id);
	}

	subtractItem(item) {
		this.storeService.removeItem(item.id);
	}

	isSelected(item) {
		let found = false;
		for (var i = this.cartItems.length - 1; i >= 0; i--) {
			if (this.cartItems[i].id == item.id) 
				found = true;
		}
		return found;
	}

	updateSearch() {
		if (this.itemquery.sort || this.itemquery.category || this.itemquery.min || this.itemquery.max) {
			this.searching = true;
			
		} else {
			this.searching = false;
		}
	}


	addItemsToPage() {
		this.itemsOnPage = this.itemsOnPage+6;
	}

	areFiltersActive( type ) {
		if ( this[type+'query'].sort != 'ASC' ) {
			return true;
		} else if ( this[type+'query'].category != null ) {
			return true;
		} else if ( this[type+'query'].filterItems != null ) {
			return true;
		} else {
			return false;
		}
	}

	openItem(i) {
		this.selectedItem = i; 
		this.selectedImage = 0; 
		this.showItemDetails = 'true';
		$("#SelectedImages ul").animate({ scrollTop: 100 });
	}

	hideDetails() { 
		setTimeout( () => {
			this.selectedImage = 0;
		}, 1000);
		this.showItemDetails = 'false';
	}


	/** 
	* Currencies
	**/
	getCurrencies() {
		if ( environment.currencies ) {
			Promise.resolve( this.storeService.getCurrencies() ).then((c) => {
				this.currencies = c;
			});

			Promise.resolve( this.storeService.getCurrency() ).then((c) => {
				this.currency = c[0];
			});

			Promise.resolve(this.storeService.enableCurrencySelector()).then((bool) => {
				this.enableCurrencySelector = bool;
			});
		}
	}

	changeCurrency(currency) {
		this.currency = currency;
		this.currencyOpen = -1;
		this.storeService.changeCurrency(currency);
	}

	createRange(number) {
		var items: number[] = [];
		for(var i = 1; i <= number; i++) { items.push(i); }		
		return items;
	}

	/**
	* Animations
	**/

	swipeImage(action = 'swipeleft', imageslength) {
        if (action === 'swipeleft') {
        	this.showImage = (this.showImage < imageslength-1) ? this.showImage+1 : this.showImage;
        	this.image.src = environment.baseUrl+'/assets'+this.items[0].images[this.showImage].url;
        }
        if (action === 'swiperight') {
        	this.showImage = (this.showImage > 0) ? this.showImage-1  : this.showImage;
        	this.image.src = environment.baseUrl+'/assets'+this.items[0].images[this.showImage].url;
        }
    }

	stagger(t = 90) {
		if (this.showCards < this.numberOfItems) {
			this.showCards++;
			setTimeout( () => { this.stagger(t); }, t);
		} else {
			this.showCards = this.numberOfItems;
		}
	}


	hoverOn(ele) {
		// console.log('hov on'+ele);
	}

	hoverOff(ele) {
		// console.log('hov off'+ele);
	}

	nextItem() {
		this.selectedImage = 0; // < this.numberOfItems-1
		this.selectedItem = (this.selectedItem < this.numberOfItems-1) ? this.selectedItem+1 : this.selectedItem;
	}

	prevItem() {
		this.selectedImage = 0;
		this.selectedItem = (this.selectedItem > 0) ? this.selectedItem-1 : 0;
	}

    /* On with the show */
	ngOnInit() {

		this.title = 'Game Items';
		this.headerHeight = '350px';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/video/video.jpg") 10%' );
		this.subtitle = 'Equip your character for survival';

		this.itemquery.sort = 'asc';
		this.itemquery.category = null;
		this.itemquery.ids = 'all';

		this.getCart();

		Promise.resolve( this.storeService.getItems(this.itemquery) ).then( (storeItems) => {
			this.allitems = storeItems;
		});

		Promise.resolve( this.storeService.countItems(this.itemquery) ).then( (count) => {
			this.numberOfItems = count;
			this.stagger();
		});

		Promise.resolve(this.storeService.getParentCategories()).then((categories) => {
			this.parentcategories = categories;
		});

		Promise.resolve(this.storeService.getCategories()).then((categories) => {
			this.categories = categories;
		});

		this.hideOwned = this.storeService.ownedHidden();
		
		this.clearFilter();
		this.getCurrencies();
		this.inAccount();

		$('html, body').animate({scrollTop: 0 }, 210);

  	}



	ngForCallback(i) {
		this.viewPanel[i] = 'both';
	}


}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/store/items/items.component.ts